package com.dignicate.web.ui.components

import androidx.compose.runtime.Composable
import com.dignicate.web.domain.AboutContent
import com.dignicate.web.theme.LocalDarkMode
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.whiteSpace
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

@Composable
fun AboutSection(content: AboutContent) {
    val isDark = LocalDarkMode.current
    Section(
        attrs = {
            id("about")
            style {
                backgroundColor(if (isDark) Color.black else Color.white)
                color(if (isDark) Color.white else Color.black)
                padding(64.px, 128.px)
            }
        }
    ) {
        P(
            attrs = {
                style {
                    whiteSpace("pre-wrap")
                }
            }
        ) {
            Text(content.description)
        }
    }
}
